import React from "react";
import Slider from "../../Components/Home/Slider";
import HomeCategory from "../../Components/Home/HomeCategory";
import CardProductsContainer from "../../Components/Products/CardProductsContainer";
import DiscountSection from "../../Components/Home/DiscountSection";
import BrandFeatured from "../../Components/Brand/BrandFeatured";
import CategoryHeader from "../../Components/Category/CategoryHeader";
import { useTranslation } from "react-i18next";
import ViewHomeProductsHooks from "../../hook/product/ViewHomeProductsHooks";
import LoadingBar from 'react-top-loading-bar'
import { Spinner } from "react-bootstrap";
import { FallingLines, ThreeDots } from "react-loader-spinner";

const HomePage = () => {
  const { t } = useTranslation();
  const [items, settingsData, adsData, Featureditems, ref, selectedOffers] = ViewHomeProductsHooks();

  //console.log('selectedOffers');
  //console.log(selectedOffers);
  return (
    <div className="font" style={{ minHeight: "670px" }}>
      <LoadingBar color='red' ref={ref} shadow={true} height={4} />

      
      {settingsData?.data && settingsData?.data?.showNavHeader === true ? <CategoryHeader /> : null}  
      <Slider />

      {settingsData?.data && settingsData?.data?.showBrand === true ? <BrandFeatured title={t("latest brands")} btntitle={t("more")} /> : null}

      {settingsData?.data && settingsData?.data?.showCategory === true ? <HomeCategory /> : null}
      {settingsData?.data && settingsData?.data?.showFeaturedProducts === true ? Featureditems?.length >= 1 ? <CardProductsContainer
        title={t("Featured Products")}
        btntitle={t("more")}
        path="products"
        products={Featureditems}
      />
        :
        <div style={{
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center'
        }}>
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color={settingsData?.data?.primaryColor}
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
        : null

      }

      {
        adsData.data && adsData.data.map(el => {
          return (el.page === "home_screen" && el.key === 1) ? <DiscountSection images={el.images} title={el.title} color={el.color} secondaryColor={el.secondaryColor} link={el.link} link2={el.link2} key={el._id} /> : null
        })
      }

      <CardProductsContainer
        title={t("Latest Products")}
        btntitle={t("more")}
        path="products"
        products={items}
      />
      {
        selectedOffers?.length >= 1 ? <CardProductsContainer
          title={t("offers")}
          btntitle={t("more")}
          path="homeOffers"
          products={selectedOffers}
        /> : null
      }




      {
        adsData.data && adsData.data.map(el => {
          return (el.page === "home_screen" && el.key === 2) ? <DiscountSection images={el.images} title={el.title} color={el.color} secondaryColor={el.secondaryColor} link={el.link} link2={el.link2} key={el._id} /> : null
        })
      }
    </div >
  );
};

export default HomePage;
